import background from "../assets/img/gif/background.gif";
import Button from "../components/Button";
import Loading from "../components/Loading";
import Select from "react-select";
import { ChevronDown, ChevronUp } from "react-feather";
import difficulties from "../data/difficulties";
import timeLimits from "../data/timeLimits";
import categories from "../data/categories";
import { Play, Info, BarChart2 } from "react-feather";
import logo from "../assets/img/logo.png";
import { useState } from "react";
import Tippy from "@tippyjs/react";
import Modal from "../components/Modal";

function IndexPage({
  category,
  setCategory,
  difficulty,
  setDifficulty,
  timeLimit,
  setTimeLimit,
  setInGame,
  setTerms,
  highScore,
}) {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  //console.log(category, difficulty, timeLimit);
  const chosenSettings =
    category?.value !== undefined &&
    difficulty?.value !== undefined &&
    timeLimit?.value !== undefined;
  return (
    <>
      <section
        className="flex flex-col items-center justify-center h-screen p-6 text-center "
        style={{
          background: `linear-gradient(
          rgba(0, 0, 0, 0.7), 
          rgba(0, 0, 0, 0.7)
        ), url(${background}) no-repeat center/cover`,
        }}
      >
        <div className="flex items-center my-5 font-serif text-5xl font-extrabold xl:text-7xl">
          <span className="text-transparent bg-clip-text bg-gradient-to-t from-blue-700 via-blue-200 to-purple-700">
            Taka <ChevronUp className="text-blue-400 " />
          </span>{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-t from-red-400 via-yellow-200 to-purple-500">
            <ChevronDown className="text-yellow-200" />
            Hiku
          </span>
        </div>
        <div className="my-8">
          <h2>
            <strong>What is more popular?</strong>
          </h2>
          <p>
            A take on{" "}
            <a
              className="text-blue-400 hover:underline"
              href="http://www.higherlowergame.com/"
            >
              The Higher Lower Game
            </a>{" "}
            for AniList.
          </p>
          <p>
            The data is sourced from the{" "}
            <a
              className="text-blue-400 hover:underline"
              href="https://anilist.gitbook.io/anilist-apiv2-docs/"
            >
              AniList API.
            </a>
          </p>
        </div>
        {isLoading ? (
          <Loading />
        ) : (
          <div className="flex flex-col items-center justify-center w-full">
            <div className="flex flex-col items-center justify-center w-full mb-8 md:flex-row">
              <div>
                <div className="flex justify-center">
                  <h3>Category</h3>
                </div>
                <Select
                  value={category}
                  className="m-2 text-black w-52"
                  onChange={(option) => setCategory(option)}
                  options={categories}
                  isSearchable={false}
                />
              </div>
              <div>
                <div className="flex justify-center">
                  <h3>Difficulty</h3>
                  <Tippy
                    content={
                      "The pool of possible terms scales with difficulty. It starts off with only the most popular terms with the hardest difficulty including some less known terms aswell. SCORE MULTIPLIER SCALES WITH DIFFICULTY"
                    }
                  >
                    <Info size={15} className="mt-1 ml-1" />
                  </Tippy>
                </div>
                <Select
                  value={difficulty}
                  className="m-2 text-black w-52"
                  onChange={(option) => setDifficulty(option)}
                  options={difficulties}
                  isSearchable={false}
                />
              </div>
              <div>
                <div className="flex justify-center">
                  <h3>Time Limit</h3>
                  <Tippy
                    content={
                      "The amount of time you have to guess if a term is higher or lower than the other. SCORE BONUS SCALES WITH TIME LIMIT"
                    }
                  >
                    <Info size={15} className="mt-1 ml-1" />
                  </Tippy>
                </div>
                <Select
                  className="m-2 text-black w-52"
                  value={timeLimit}
                  onChange={(option) => setTimeLimit(option)}
                  options={timeLimits}
                  isSearchable={false}
                />
              </div>
            </div>
            {isLoading ? (
              <div className="w-8 h-8 m-1 ease-linear border-4 border-t-4 border-white border-opacity-25 rounded-full loader" />
            ) : (
              <Button
                className={`bg-transparent border-2 border-white hover:bg-white hover:text-black ${
                  chosenSettings ? "visible" : "invisible"
                }`}
                text="Start"
                icon={<Play />}
                onClick={() => {
                  setIsLoading(true);
                  fetchTerms(category, difficulty)
                    .then((results) => setTerms(results))
                    .finally(() => {
                      setIsLoading(false);
                      setInGame(true);
                    });
                }}
              />
            )}
            <div className="absolute top-0 left-0 w-full px-4 py-4 lg:top-auto lg:bottom-0">
              Made by{" "}
              <a
                className="text-blue-400 hover:underline"
                href="https://anilist.co/user/poutingemoji/"
              >
                <img
                  className="inline-block"
                  width={20}
                  src={logo}
                  alt="logo"
                />{" "}
                poutingemoji
              </a>
            </div>
            <div className="absolute bottom-0 right-0 flex items-end justify-between w-full px-4 py-4 lg:bottom-auto lg:top-0 lg:items-start">
              <BarChart2
                className="flex cursor-pointer"
                onClick={() => setShowModal(true)}
              />
              <div className="text-left">
                <h1>
                  Score Multiplier:{" "}
                  <span className="font-mono font-bold">
                    x
                    {difficulty?.value === undefined
                      ? 0
                      : difficulty.scoreMultiplier}
                  </span>
                </h1>
                <h1>
                  Base Score:{" "}
                  <span className="font-mono font-bold">
                    100
                    {timeLimit?.value === undefined
                      ? ""
                      : ` + ${timeLimit.scoreBonus}`}
                  </span>
                </h1>
              </div>
            </div>
          </div>
        )}
      </section>
      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        highScore={highScore}
      />
    </>
  );
}

export default IndexPage;

async function fetchTerms(category, difficulty) {
  let page = 1;
  let results = [];
  while (true) {
    //console.log(category.query);
    const res = await fetch("https://graphql.anilist.co", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        query: category.query,
        variables: {
          page,
          perPage: 50,
        },
      }),
    });
    const result = await res.json();
    page++;
    if (result.data.Page.hasOwnProperty("media")) {
      const terms = result.data.Page.media;
      for (let i = 0; i < terms.length; i++) {
        const media = terms[i];
        results.push({
          name:
            media.title?.english || media.title?.romanji || media.title.native,
          image: media.coverImage.extraLarge,
          value: media.popularity,
          color: media.coverImage.color,
          category: media.type,
        });
        //console.log(results.length, difficulty.value);
        if (results.length >= difficulty.value) break;
      }
    } else if (result.data.Page.hasOwnProperty("characters")) {
      const characters = result.data.Page.characters;
      for (let i = 0; i < characters.length; i++) {
        const character = characters[i];
        results.push({
          name: character.name.full,
          image: character.image.large,
          value: character.favourites,
          color: getColor(),
          category: "CHARACTER",
        });
        //console.log(results.length, difficulty.value);
        if (results.length >= difficulty.value) break;
      }
    }
    if (
      !result.data.Page.pageInfo.hasNextPage ||
      results.length >= difficulty.value
    )
      break;
  }
  //console.log(results);
  return results;
}

function getColor() {
  return (
    "hsl(" +
    360 * Math.random() +
    "," +
    (25 + 70 * Math.random()) +
    "%," +
    (85 + 10 * Math.random()) +
    "%)"
  );
}
